import Vue from 'vue';
export const EventBus = new Vue();


// WEBPACK FOOTER //
// ./_common/event-bus.js